import React, { Component } from 'react';
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from 'react-router-dom';

import utils from './utils/utils';
import ErrorBoundary from './components/ErrorBoundary';

// 新的google search console
import GoogleSearchConsoleV2 from './pages/Admin/AdvancedSettings/GoogleSearchConsoleV2/indexNew'

// Error 404 / 500
import NotFound from './pages/Admin/Error/pageNotFound';
import ErrorPage from './pages/Admin/Error/error';
import CookieError from './pages/Admin/Error/cookieError';

// 推广页面
import Affiliate from './pages/Affiliate/index';

//首页 分数页面
import dashboard from './pages/Admin/DashboardV2/indexNew';
// 验证
import install from './pages/Admin/Install/index';
import websiteCheck from './pages/Admin/WebsiteCheck/indexNew';
// 速度优化
import SiteSpeedup from './pages/Admin/SiteSpeedup/indexNew';
//AMP
import ServiceAMP from './pages/Admin/ServiceAMP/indexNew';
import ServiceAMPCustome from './pages/Admin/ServiceAMP/custome/indexNew';
// On Page SEO
import OnPageSEOIndex from './pages/Admin/OnPageSEO/index/indexNew';
// import OnPageSEODetail from './pages/Admin/OnPageSEO/index/components/SheetDetail/indexNew';
import ContentAuditDetail from './pages/Admin/OnPageSEO/ContentAuditDetail/indexNew';

// Bulk Edit
import manualBulkEdit from './pages/Admin/BulkEditTag/indexNew';
// 图片alt
import ImageAltText from './pages/Admin/ImageAltText/indexNew';
import ImageOptAltDetail from './pages/Admin/ImageAltText/historyTable/detail/indexNew'

//Broken Links
import BrokenLinkViewErrors from './pages/Admin/BrokenLink/indexNew';
// Structured Data
import StructuredData from './pages/Admin/SnippetsJSONLD/index/indexNew';
import Organization from './pages/Admin/SnippetsJSONLD/Organization/indexNew';
import ProductSchema from './pages/Admin/SnippetsJSONLD/ProductSchema/indexNew';
// HtmlSitemap
import HtmlSitemap from './pages/Admin/HtmlStiemap/index/indexNew';
// 外链互换
import ExchangeBacklink from './pages/Admin/ExchangeBacklink/indexNew';
// 外链审查
import BacklinkAudit from './pages/Admin/BacklinkAudit/indexNew';
//价格页面
// 2021-10-20 : 开放免费用户权限
import Pricing from './pages/Admin/Pricing/index/indexNew';
import OldPricing from './pages/Admin/Pricing/oldversion/indexNew';
// 图片压缩V2
import ImageOptimization from './pages/Admin/PageSpeed/indexV2/indexNew'
import ImageOptimizationDetail from './pages/Admin/PageSpeed/indexV2/detail/indexNew'
import ImageOptimizationSettings from './pages/Admin/PageSpeed/indexV2/setting/indexNew'
import Integration from './pages/Admin/Integration/indexNew';
// 关键词规划
import KeywordContentPlanner from './pages/Admin/KeywordContentPlanner/indexNew';
// 关键词规划详情
import ContentPlannerDetail from './pages/Admin/KeywordContentPlanner/ContentPlannerDetail/indexNew';
// 博客生成器
import AiBlogGenerator from './pages/Admin/AiBlogGenerator/indexNew';
import GenerateProgress from './pages/Admin/AiBlogGenerator/GenerateProgress/indexNew';
// 关键词
import Keywords from './pages/Admin/Keywords/indexNew';
// 竞品关键词
import CompetitorKeywordsDetail from './pages/Admin/CompetitorKeywordsDetail/indexNew';
// 关键词搜索
import KeywordsSearch from './pages/Admin/KeywordsSearch/indexNew';
// 关键词对比
import KeywordsGap from './pages/Admin/KeywordsGap/indexNew';
// 竞争网站对比
import KeywordsMonitor from './pages/Admin/KeywordsMonitor/indexNew';
// canny页面
import Canny from './pages/Admin/Canny/indexNew';
// Instant Index
import InstantIndex from './pages/Admin/InstantIndex/indexNew';
// 设置页面
import Settings from './pages/Admin/Settings/indexNew';
// 报告入口
import ReportData from './pages/Admin/ReportData/indexNew';
// 新手引导
import NewUserGuide from './pages/Admin/NewUserGuide/indexNew';
// 网站验证
import SiteVerification from './pages/Admin/SiteVerify/indexNew';
// 爬取索引
import CrawlingIndexing from './pages/Admin/CrawlingIndexing/indexNew';
// llms.txt
import LlmsTxt from './pages/Admin/llmsTxt/indexNew';
// SEOMetadata
import SEOMetadata from './pages/Admin/SEOMetadata/indexNew';

class BasicRoute extends Component {
  state = {}

  requireAuth = (Layout, props) => { // 登录验证    
    const isShopify = window.shopify;
    const params = new URLSearchParams(window.location.search);
    // let locale = params.get("locale");
    // let host = params.get("host");
    // let shop = params.get("shop");
    // let session = params.get("session");
    let olduser = params.get("olduser");
    if (olduser) {
      window.oldUser = olduser;
    }

    if (!isShopify) {
      // 如果存在这个东西表示是从我们超管后台进来的，不执行搭桥
      let authToken = params.get("authToken") || utils.getStore('authToken');
      if (authToken && authToken.length >= 32) {
        utils.setStore('authToken', authToken);
        return <Layout {...props} />
      }
    }
    return <Layout {...props} />
  }

  render() {
    return (
      <ErrorBoundary>
        <Switch>
          {/* user auth */}
          <Route path="/" exact component={install} />

          {/* <Route exact path="/" render={() => <Redirect to='/dashboard'></Redirect>} /> */}

          {/* dashboard score */}
          <Route path="/dashboard" exact component={props => this.requireAuth(dashboard, props)} />
          {/* canny */}
          <Route path="/dashboard/Feedback" exact component={props => this.requireAuth(Canny, props)} />
          {/* Integration APP列表页 */}
          <Route path="/dashboard/integration" exact component={props => this.requireAuth(Integration, props)} />

          {/* 推广页面 */}
          <Route path="/affiliate" component={Affiliate} />

          {/* 入口页面 */}
          <Route exact path="/speedOpt" component={props => this.requireAuth(SiteSpeedup, props)} />
          <Route exact path="/content-seo" component={props => this.requireAuth(KeywordContentPlanner, props)} />
          <Route exact path="/on-page-seo" component={props => this.requireAuth(OnPageSEOIndex, props)} />
          <Route exact path="/technicalSEO" component={props => this.requireAuth(BrokenLinkViewErrors, props)} />
          <Route exact path="/keywordRearch" component={props => this.requireAuth(Keywords, props)} />
          <Route exact path="/backlinks" component={props => this.requireAuth(ExchangeBacklink, props)} />
          <Route path="/reports" exact component={props => this.requireAuth(ReportData, props)} />

          {/* SEO Checker */}
          <Route path="/website-check" exact component={props => this.requireAuth(websiteCheck, props)} />

          {/* 爬取索引 */}
          <Route path="/technicalSEO/crawling-indexing" exact component={props => this.requireAuth(CrawlingIndexing, props)} />
          <Route path="/technicalSEO/llms-txt" exact component={props => this.requireAuth(LlmsTxt, props)} />

          {/* SEOMetadata */}
          <Route path="/on-page-seo/seo-metadata" exact component={props => this.requireAuth(SEOMetadata, props)} />

          {/* Structured Data */}
          <Route exact path="/technicalSEO/structured-data" component={props => this.requireAuth(StructuredData, props)} />
          <Route exact path="/technicalSEO/structured-data/organization" component={props => this.requireAuth(Organization, props)} />
          <Route exact path="/technicalSEO/structured-data/product" component={props => this.requireAuth(ProductSchema, props)} />

          {/* HTMLSitemap */}
          <Route exact path="/technicalSEO/html-sitemap" component={props => this.requireAuth(HtmlSitemap, props)} />

          {/* Broken Links */}
          <Route path="/technicalSEO/broken-link/view-errors" exact component={props => this.requireAuth(BrokenLinkViewErrors, props)} />

          {/* 外链互换 */}
          <Route exact path="/backlinks/exchange-backlink" component={props => this.requireAuth(ExchangeBacklink, props)} />
          {/* 外链审查 */}
          <Route exact path="/backlinks/backlink-audit" component={props => this.requireAuth(BacklinkAudit, props)} />

          {/* 网站验证 */}
          <Route path="/technicalSEO/site-verification" exact component={props => this.requireAuth(SiteVerification, props)} />

          {/* Instant Index */}
          <Route exact path="/technicalSEO/instant-index" component={props => this.requireAuth(InstantIndex, props)} />

          {/* On Page SEO */}
          <Route path="/on-page-seo/list" exact component={props => this.requireAuth(OnPageSEOIndex, props)} />
          {/* <Route path="/on-page-seo/detail" exact component={props => this.requireAuth(OnPageSEODetail, props)} /> */}
          <Route path="/on-page-seo/content-edit" exact component={props => this.requireAuth(ContentAuditDetail, props)} />


          {/* Bulk Edit V2 */}
          <Route path="/on-page-seo/bulk-edit/manual-bulk-edit" exact component={props => this.requireAuth(manualBulkEdit, props)} />

          {/* 图片alt */}
          <Route exact path="/on-page-seo/image-alt-text" component={props => this.requireAuth(ImageAltText, props)} />
          <Route exact path="/on-page-seo/image-alt-text/details" component={props => this.requireAuth(ImageOptAltDetail, props)} />

          {/* 图片压缩V2 */}
          <Route exact path="/speedOpt/PageSpeed" component={props => this.requireAuth(ImageOptimization, props)} />
          {/* 图片压缩详情 */}
          <Route exact path="/speedOpt/PageSpeed/details" component={props => this.requireAuth(ImageOptimizationDetail, props)} />
          {/* 图片压缩设置页 */}
          <Route exact path="/speedOpt/PageSpeed/settings" component={props => this.requireAuth(ImageOptimizationSettings, props)} />

          {/* AI - 关键词规划 */}
          <Route path="/content-seo/keyword-content-planner" exact component={props => this.requireAuth(KeywordContentPlanner, props)} />
          <Route path="/content-seo/keyword-content-planner/detail" exact component={props => this.requireAuth(ContentPlannerDetail, props)} />

          {/* AI - 博客生成器 */}
          <Route path="/content-seo/ai-blog-generator" exact component={props => this.requireAuth(AiBlogGenerator, props)} />
          <Route path="/content-seo/ai-blog-generator/generate" exact component={props => this.requireAuth(GenerateProgress, props)} />

          {/* 关键词 */}
          <Route path="/keywordRearch/keywords-data" exact component={props => this.requireAuth(Keywords, props)} />

          {/* Competitor Keywords Detail */}
          <Route path="/keywordRearch/keywords-research/Competitor-keywords-detail" exact component={props => this.requireAuth(CompetitorKeywordsDetail, props)} />

          {/* 关键词搜索 */}
          <Route path="/keywordRearch/keywords-search" exact component={props => this.requireAuth(KeywordsSearch, props)} />

          {/* 关键词对比 */}
          <Route path="/keywordRearch/keywords-gap" exact component={props => this.requireAuth(KeywordsGap, props)} />

          {/* 竞品网站对比 */}
          <Route path="/keywordRearch/keywords-monitor" exact component={props => this.requireAuth(KeywordsMonitor, props)} />

          {/* 新的 Google Search Console */}
          <Route path="/keywordRearch/GoogleSearchConsoleV2" exact component={props => this.requireAuth(GoogleSearchConsoleV2, props)} />

          {/* SEO Expert Services */}
          <Route path="/speedOpt/site-speedup" exact component={props => this.requireAuth(SiteSpeedup, props)} />

          {/* SEOWILL AMP */}
          <Route path="/speedOpt/seo-ant-amp" exact component={props => this.requireAuth(ServiceAMP, props)} />
          <Route path="/speedOpt/seo-ant-amp/custome" exact component={props => this.requireAuth(ServiceAMPCustome, props)} />

          {/* Pricing */}
          {/*// 2021-10-20 : 开放免费用户权限*/}
          {/* 新版价格页 */}
          <Route path="/plan" component={props => this.requireAuth(Pricing, props)} />
          {/* 旧版价格页 */}
          <Route path="/oldversion/pricing" component={props => this.requireAuth(OldPricing, props)} />

          {/* 设置页面 */}
          <Route path="/settings" component={props => this.requireAuth(Settings, props)} />

          {/* 新手引导 */}
          <Route path="/guide" component={props => this.requireAuth(NewUserGuide, props)} />

          {/* 异常处理 500 */}
          <Route path="/error" component={ErrorPage} />
          <Route path="/cookieError" component={CookieError} />

          {/* 异常处理 404 */}
          <Route path="/404" component={NotFound} />
          <Redirect to="/404"></Redirect>

        </Switch>
        {/* 语言loading判断 */}
      </ErrorBoundary>
    );
  }
}

export default withRouter(BasicRoute);
